import { AuthSession, AuthUser } from '@aws-amplify/auth';
import { UseAuthenticator } from '@aws-amplify/ui-react';
import * as React from 'react';

export type JwtPayload = AuthSession['tokens']['idToken']['payload']

export interface AmplifyContextProps {
  signOut: UseAuthenticator['signOut'] | undefined;
  user: AuthUser | undefined | any;
  idToken: string | undefined;
  // Unix seconds. Consumers that hand the id token to a server need to know whether it
  // is still usable before they do: the audio websocket cannot read the resulting 401
  // (the browser exposes no status for a failed WebSocket handshake), so it has to
  // decide up front rather than discover the rejection.
  idTokenExpiresAt: number | undefined;
  refreshToken: () => void;
}

export const AmplifyContext = React.createContext<AmplifyContextProps>(null as unknown as AmplifyContextProps);

export default function useAmplifyContext() {
  return React.useContext(AmplifyContext);
}
